var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              placeholder: "Informe o número do recibo",
              configuracaoFiltro: _vm.configuracaoFiltro,
              showFiltroTipoMultiplo: _vm.filtro.showFiltroTipoProcessoMultiplo
            },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.clear }
          })
        ],
        1
      ),
      _c("app-listagem", {
        attrs: {
          tituloCard: "Cadastros Existentes",
          "font-size-titulo-card": "24px",
          "header-label": "Listagem de cadastros",
          hasRowClick: true,
          jsonHeaders: _vm.colunas,
          jsonData: _vm.items,
          pagina: _vm.filtro.pagina,
          totalElements: _vm.totalElements,
          filtro: _vm.filtro
        },
        on: {
          rowClick: _vm.visualizarDetalhesCadastro,
          updateListagem: _vm.refresh,
          changePage: _vm.changePage,
          sort: _vm.sort,
          executar: _vm.executar
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68e1fcbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e1fcbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/receptor/ListagemCadastrosPendentes.vue
// module id = null
// module chunks = 